import Chart from 'chart.js/auto';
import './stackedBar.colors.scss';
import styling from '../core/styling';
import { create, createDiv } from '../core/domMan';
import { modeSpecificCssVariable } from '../core/themeColorsPicker';

export const identifier = 'stackedBar';
export const wrapperName = `${identifier}Wrapper`;
const fadeIn = styling.getAnimationCss(styling.animations.fadeIn);

const jDateIt = (raw) => {
    const date = new Date(raw);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}-${year}`;
}

export const createChart = (parentElement, chartArgs, displayedMode, agendaZone) => {

    const previous = Chart.getChart(identifier);
    if (!!previous) {
        previous.destroy();
    }
    while (parentElement.lastElementChild) {
        parentElement.removeChild(parentElement.lastElementChild);
    }

    while (agendaZone?.lastElementChild) {
        agendaZone.removeChild(agendaZone.lastElementChild);
    }

    const { data, type, sets, specialStartLabel } = chartArgs;
    data.sort((a, b) => new Date(a.TimeGenerated) - new Date(b.TimeGenerated));

    const wrapper = createDiv(parentElement, { id: wrapperName, className: `items-center container hideOnSmall` });
    const commonClasses = 'flex w-full';
    const chartPlaceholder = createDiv(wrapper, { className: `w-full h-full` });
    const down = createDiv(agendaZone ?? wrapper, { className: `${commonClasses} ${fadeIn} hideOnSmall` });
    const canvas = create(chartPlaceholder, 'canvas', { id: identifier });
    styling.hide(canvas);
    if (!sets.length || !data.length) {
        return canvas;
    }
    const firstTime = specialStartLabel ?? jDateIt(data[0].TimeGenerated);
    const bottomLeft = createDiv(down, { id: `${wrapperName}-left`, className: `flex flex-1 justify-start mx-1`, innerText: firstTime });
    const bottomRight = createDiv(down, { id: `${wrapperName}-right`, className: `flex flex-1 justify-end mx-1`, innerText: 'Now' });
    const labels = [firstTime, ...Array(data.length - 2).fill(''), 'Now'];

    const datasets = sets.map(definition => {
        return {
            label: definition.label,
            data: data.map(element => element[definition.field]),
            backgroundColor: modeSpecificCssVariable(displayedMode, `--color-${definition.cssColor}`),
            borderWidth: 0,
        }
    });

    const chart = new Chart(
        canvas,
        {
            type,
            data: { labels },
            options: {
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                        display: false,
                        ticks: { autoSkip: true },
                        grid: { display: false },
                    },
                    y: { display: false, stacked: true },
                },
                plugins: { legend: { display: false } }
            }
        });

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    delay(100)
        .then(() => {
            chart.data.datasets = datasets;
            chart.update();
            return delay(500);
        })
        .then(() => {
            canvas.className = fadeIn;
        });
    return canvas;
}